export function selectedCatFeederScope(catId: string, feederId: string, days: number) {
  return {
    catId,
    feederId,
    rpcParams: { p_cat_id: catId, p_feeder_id: feederId, p_days: days }
  };
}
